import { render, staticRenderFns } from "./DistributionPanelboard.vue?vue&type=template&id=5326e1fe&scoped=true&"
import script from "./DistributionPanelboard.vue?vue&type=script&lang=js&"
export * from "./DistributionPanelboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5326e1fe",
  null
  
)

export default component.exports